import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const CatalogoPublico = () => {
  const { codigo } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [catActivo, setCatActivo] = useState(0);
  const [imagenModal, setImagenModal] = useState(null);

  useEffect(() => {
    const fetchCatalogo = async () => {
      try {
        const res = await axios.get(`${API_URL}/public/catalogo/${codigo}`);
        setData(res.data);
      } catch {
        setError('Catálogo no encontrado o no disponible.');
      } finally {
        setLoading(false);
      }
    };
    fetchCatalogo();
  }, [codigo]);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
      <div style={{ textAlign: 'center', color: '#6b7280' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🛍️</div>
        <p>Cargando catálogo...</p>
      </div>
    </div>
  );

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
      <div style={{ textAlign: 'center', color: '#6b7280', maxWidth: '400px', padding: '2rem' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>😕</div>
        <h2 style={{ color: '#374151', marginBottom: '0.5rem' }}>Catálogo no disponible</h2>
        <p>{error}</p>
      </div>
    </div>
  );

  const catalogoActivo = data.catalogos[catActivo];

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: 'system-ui, sans-serif' }}>

      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
        padding: '2rem 1.5rem',
        textAlign: 'center',
        color: 'white',
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🛍️</div>
        <h1 style={{ margin: '0 0 0.25rem', fontSize: '1.6rem', fontWeight: '800' }}>{data.negocio}</h1>
        <p style={{ margin: 0, opacity: 0.85, fontSize: '0.9rem' }}>Catálogo de productos</p>
      </div>

      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '1.5rem' }}>

        {data.catalogos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '4rem', color: '#9ca3af' }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>📦</div>
            <p>Este negocio aún no tiene productos publicados.</p>
          </div>
        ) : (
          <>
            {/* Tabs de catálogos */}
            {data.catalogos.length > 1 && (
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
                {data.catalogos.map((cat, idx) => (
                  <button
                    key={cat.id}
                    onClick={() => setCatActivo(idx)}
                    style={{
                      padding: '0.4rem 1rem', borderRadius: '20px',
                      border: '2px solid #2563eb',
                      background: catActivo === idx ? '#2563eb' : 'white',
                      color: catActivo === idx ? 'white' : '#2563eb',
                      fontWeight: '600', fontSize: '0.85rem', cursor: 'pointer',
                      transition: 'all 0.15s',
                    }}
                  >
                    {cat.nombre}
                    <span style={{ marginLeft: '0.35rem', opacity: 0.75, fontSize: '0.75rem' }}>
                      ({cat.productos.length})
                    </span>
                  </button>
                ))}
              </div>
            )}

            {/* Descripción del catálogo */}
            {catalogoActivo?.descripcion && (
              <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem', lineHeight: '1.5' }}>
                {catalogoActivo.descripcion}
              </p>
            )}

            {/* Grid de productos */}
            {!catalogoActivo?.productos?.length ? (
              <div style={{ textAlign: 'center', padding: '3rem', color: '#9ca3af' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>📦</div>
                <p>Este catálogo no tiene productos aún.</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '1.25rem' }}>
                {catalogoActivo.productos.map(prod => {
                  let imgs = [];
                  if (prod.imagen) {
                    try { imgs = JSON.parse(prod.imagen); if (!Array.isArray(imgs)) imgs = [prod.imagen]; }
                    catch { imgs = [prod.imagen]; }
                  }
                  return (
                    <div key={prod.id} style={{
                      background: 'white', borderRadius: '14px',
                      overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                      transition: 'transform 0.15s, box-shadow 0.15s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.07)'; }}
                    >
                    {/* Imagen principal */}
                    {imgs.length > 0 ? (
                      <div>
                        <img src={imgs[0]} alt={prod.nombre}
                          onClick={() => setImagenModal(imgs[0])}
                          style={{ width: '100%', height: '200px', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />
                        {imgs.length > 1 && (
                          <div style={{ display: 'flex', gap: '4px', padding: '4px', background: '#f9fafb' }}>
                            {imgs.slice(1).map((img, i) => (
                              <img key={i} src={img} alt={`${prod.nombre}-${i+2}`}
                                onClick={() => setImagenModal(img)}
                                style={{ width: '60px', height: '50px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }} />
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div style={{ width: '100%', height: '140px', background: 'linear-gradient(135deg, #f3f4f6, #e5e7eb)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem', color: '#d1d5db' }}>
                        📦
                      </div>
                    )}

                    <div style={{ padding: '1rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.4rem' }}>
                        <h3 style={{ margin: 0, fontSize: '0.95rem', fontWeight: '700', color: '#111827', lineHeight: '1.3' }}>{prod.nombre}</h3>
                        {prod.precio > 0 && (
                          <span style={{
                            background: 'linear-gradient(135deg, #059669, #10b981)',
                            color: 'white', borderRadius: '8px',
                            padding: '0.2rem 0.6rem', fontSize: '0.82rem', fontWeight: '700',
                            flexShrink: 0, marginLeft: '0.5rem',
                          }}>
                            ${parseFloat(prod.precio).toFixed(2)}
                          </span>
                        )}
                      </div>

                      {prod.descripcion && (
                        <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', color: '#6b7280', lineHeight: '1.45' }}>
                          {prod.descripcion}
                        </p>
                      )}

                      {prod.condiciones && (
                        <div style={{
                          marginTop: '0.5rem', padding: '0.4rem 0.6rem',
                          background: '#fffbeb', border: '1px solid #fde68a',
                          borderRadius: '6px', fontSize: '0.75rem', color: '#92400e',
                        }}>
                          📋 {prod.condiciones}
                        </div>
                      )}
                    </div>
                  </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af', fontSize: '0.8rem', borderTop: '1px solid #e5e7eb', marginTop: '2rem' }}>
        Powered by <strong style={{ color: '#2563eb' }}>FactuTracks</strong>
      </div>

      {/* Modal imagen */}
      {imagenModal && (
        <div
          onClick={() => setImagenModal(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', cursor: 'zoom-out' }}
        >
          <img src={imagenModal} alt="producto"
            style={{ maxWidth: '90vw', maxHeight: '88vh', borderRadius: '12px', objectFit: 'contain' }} />
        </div>
      )}
    </div>
  );
};

export default CatalogoPublico;
